import appConfig from "../appconfig";
import {ADD_PRODUCT_SELECTION_TO_CART, SET_VOUCHER_PRODUCT_ADD_TO_CART} from "../store/mutation-types";
import routeMapper from "../router/routeMapper";
import ProductSelection from "../domains2/orders/ProductSelection";
import {filterCurrentUserFavoriteProductListByShopId} from "../libraries/utils";
import * as mutationTypes from "../store/mutation-types";


async function voucherProductAddToCartGt2(thisObj) {
	const {productId, voucherId} = thisObj.$store.getters.voucherReward || {};
	const globalSelectedShop = thisObj.$store.getters.globalSelectedShop;
	if (globalSelectedShop) {
		if (productId) {
			await addProductToCart(thisObj, productId, voucherId);
			thisObj.$router.push({
				name: routeMapper.routeNames.checkoutCart,
				params: {
					voucherCode: voucherId
				}
			});
		}
	} else {
		thisObj.$router.push({
			name: routeMapper.routeNames.shopSelection
		});
	}
}

async function addProductToCart(thisObj, productId, voucherId) {
	const psOptions = {
		expiration: {
			tenantSettings: thisObj.$store.getters.tenantSettings.productSelectionExpiration,
			tenantConfig: appConfig.tenantConfig.productSelectionExpiration
		}
	};
	let product;
	try {
		const validProductId = filterCurrentUserFavoriteProductListByShopId(
			[{productId}],
			thisObj.$store.getters.productCatalog,
			thisObj.$store.getters.globalSelectedShop.id,
			thisObj.$store.getters.cachedPickupRules
		)[0];
		product = thisObj.$store.getters.productCatalog.getProduct(validProductId);
	} catch(_) {
		thisObj.$store.commit(mutationTypes.SET_GLOBAL_INFO_DIALOG, "utilityComponents.voucherInput.invalidShop");
	} finally {
		thisObj.$store.commit(SET_VOUCHER_PRODUCT_ADD_TO_CART, null);
	}
	if(!product) {
		return;
	}
	const ps = ProductSelection.createFromProduct(product, psOptions);
	ps.quantity = ps.quantity || 1;
	ps.voucherId = voucherId;
	await thisObj.$store.dispatch(ADD_PRODUCT_SELECTION_TO_CART, ps);
}

export {voucherProductAddToCartGt2, addProductToCart};